import React from 'react';

export default function BlockerCloseButton({onClick}) {
  if(!onClick) {
    return null;
  }

  return <button className="close-btn" onClick={onClick}>&times;</button>;
};
